export const blogPostsQuery = `
  *[_type == "blogPost"] | order(date desc){
    _id,
    title,
    slug,
    date,
    summary,
    headerImage,
    picture1,
    picture2,
    picture3,
    subtitle1,
    subtitle2,
    subtitle3,
    text1,
    text2,
    text3,

    author->{
      name,
      image
    }
  }
`